<template>
  <move-template :order-type="orderType" :type="type"/>
</template>

<script>
import MoveTemplate from '@/views/operation/movebound/MoveTemplate.vue'

export default {
  name: 'LocationMoveOrder',
  components: { MoveTemplate },
  props: {
    queryParam: { type: Object, default: null }
  },
  data() {
    return {
      type: 'adjustmentTransfer',
      orderType: { id: this.queryParam.value.business.orderTypeId }
    }
  },
  methods: {}
}
</script>